import { render, staticRenderFns } from "./TicketConfirmation.vue?vue&type=template&id=6210292e&"
import script from "./TicketConfirmation.vue?vue&type=script&lang=js&"
export * from "./TicketConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports